// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../styles/interview-theme.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================
   INPUT - G42 BRANDING
   ========================================== */

.interview-input-group {
  display: flex;
  flex-direction: column;
  gap: var(--interview-space-sm);
}

.interview-input-label {
  font-size: var(--interview-text-sm);
  font-weight: var(--interview-text-semibold);
  color: var(--interview-text-muted);
}

.interview-input {
  width: 100%;
  padding: var(--interview-space-md) var(--interview-space-lg);
  border: 1px solid var(--interview-border-default);
  border-radius: var(--interview-radius-lg);
  font-size: var(--interview-text-base);
  font-family: var(--interview-font-primary);
  transition: all var(--interview-transition-base);
  background-color: var(--interview-bg-card);
  color: var(--interview-text-primary);
  font-weight: var(--interview-text-regular);
}

.interview-input:focus {
  outline: none;
  border-color: var(--interview-brand-primary);
  background-color: var(--interview-bg-white);
  box-shadow: var(--interview-shadow-focus);
}

.interview-input:disabled {
  background-color: var(--interview-bg-card);
  cursor: not-allowed;
  color: var(--interview-text-muted);
  border-color: var(--interview-border-default);
  opacity: 0.6;
}

.interview-input::placeholder {
  color: var(--interview-text-disabled);
  font-weight: var(--interview-text-regular);
}
`, "",{"version":3,"sources":["webpack://./src/components/Interview/shared/Input.css"],"names":[],"mappings":"AAAA;;+CAE+C;;AAI/C;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,mCAAmC;EACnC,2CAA2C;EAC3C,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,4DAA4D;EAC5D,iDAAiD;EACjD,yCAAyC;EACzC,qCAAqC;EACrC,0CAA0C;EAC1C,gDAAgD;EAChD,0CAA0C;EAC1C,oCAAoC;EACpC,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,4CAA4C;EAC5C,2CAA2C;EAC3C,yCAAyC;AAC3C;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;EACnB,kCAAkC;EAClC,6CAA6C;EAC7C,YAAY;AACd;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;AAC5C","sourcesContent":["/* ==========================================\n   INPUT - G42 BRANDING\n   ========================================== */\n\n@import '../../../styles/interview-theme.css';\n\n.interview-input-group {\n  display: flex;\n  flex-direction: column;\n  gap: var(--interview-space-sm);\n}\n\n.interview-input-label {\n  font-size: var(--interview-text-sm);\n  font-weight: var(--interview-text-semibold);\n  color: var(--interview-text-muted);\n}\n\n.interview-input {\n  width: 100%;\n  padding: var(--interview-space-md) var(--interview-space-lg);\n  border: 1px solid var(--interview-border-default);\n  border-radius: var(--interview-radius-lg);\n  font-size: var(--interview-text-base);\n  font-family: var(--interview-font-primary);\n  transition: all var(--interview-transition-base);\n  background-color: var(--interview-bg-card);\n  color: var(--interview-text-primary);\n  font-weight: var(--interview-text-regular);\n}\n\n.interview-input:focus {\n  outline: none;\n  border-color: var(--interview-brand-primary);\n  background-color: var(--interview-bg-white);\n  box-shadow: var(--interview-shadow-focus);\n}\n\n.interview-input:disabled {\n  background-color: var(--interview-bg-card);\n  cursor: not-allowed;\n  color: var(--interview-text-muted);\n  border-color: var(--interview-border-default);\n  opacity: 0.6;\n}\n\n.interview-input::placeholder {\n  color: var(--interview-text-disabled);\n  font-weight: var(--interview-text-regular);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
